import { _t } from '../components/base'

export function initSystemTranslations() {
    siTranslations()
    hrTranslations()
}

function siTranslations() {
    if (typeof editorLang !== 'undefined' && editorLang === 'si') {
        $('.add-to-cart-button').text('Dodaj v košarico')

        document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
            $('.advanced-order .btn.btn-conversion').text('Dodaj v košarico')
            $('.advanced-order .h1').html((i, t) => t.replace('Added to cart', 'Dodano v košarico'))
            $('.advanced-order .h1.advanced-order-suggestion').html((i, t) =>
                t.replace('Other customers also bought', 'Tudi drugi kupci so kupili')
            )

            const freeShippingPrice = getShoptetDataLayer('cartInfo').leftToFreeShipping.formattedPrice

            $('.extra.delivery span strong').each(function () {
                if ($(this).text().trim() === 'You have free delivery!') {
                    $(this).text(_t('global.freeDelivery'))
                }
            })
        })

        loginTranslations()

        $('.extra.delivery.shipping-is-free span strong').text(_t('global.freeDelivery'))
        $('.id--17 .co-contact-information .btn').text('Dnevnik')
        globalTranslations()

        document.addEventListener('ShoptetDOMPageContentLoaded', function () {
            globalTranslations()
        })
    }
}

function hrTranslations() {
    if (typeof editorLang !== 'undefined' && editorLang === 'hr') {
        $('.add-to-cart-button').text('Dodaj u košaricu')
        loginTranslations()

        document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
            $('.advanced-order .btn.btn-conversion').text('Dodaj u košaricu')
            $('.add-to-cart-button').text('Dodaj u košaricu')

            $('.extra.delivery span strong').each(function () {
                if ($(this).text().trim() === 'You have free delivery!') {
                    $(this).text(_t('global.freeDelivery'))
                }
            })
        })

        // $('.ordering-process .extra.delivery span').text('')
        $('.id--17 .co-contact-information .btn').text('Prijava')
        $('.next-step.next-step--step-2 .next-step-back').text('Povratak')
        $('.next-step.next-step--step-1 .next-step-back').text('Povratak')
        globalTranslations()

        document.addEventListener('ShoptetDOMPageContentLoaded', function () {
            globalTranslations()
        })
    }
}

function loginTranslations() {
    $('.user-action-login > h2').text(_t('login.title'))
    $('.btn-login').text(_t('login.button'))
    $('.password-helper a:last').text(_t('login.forgotPassword'))
    $('.password-helper a:first').text(_t('login.createAccount'))
}

function globalTranslations() {
    $('form label[for="order1"]').text(_t('filter.recommended'))
    $('form label[for="order2"]').text(_t('filter.leastExpensive'))
    $('form label[for="order3"]').text(_t('filter.mostExpensive'))
    $('form label[for="order4"]').text(_t('filter.alphabetically'))

    setTimeout(() => {
        $('.ec-v-forms-form-control').attr('placeholder', _t('email.placeholder'))
    }, 500)
}
